module.exports = __webpack_public_path__ + "static/media/trip.5a2fdb75.png";